import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "pb-5" }
const _hoisted_2 = { class: "wrapContainer" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "big mb-2" }
const _hoisted_5 = { class: "text-primary" }
const _hoisted_6 = { class: "small fw-light" }
const _hoisted_7 = {
  key: 0,
  class: "pt-4"
}
const _hoisted_8 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_9 = { class: "text-center mb-1" }
const _hoisted_10 = { class: "lowTitle" }
const _hoisted_11 = { class: "text-center mt-5" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_15 = { class: "d-flex justify-content-around mt-4" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_mega_spinner = _resolveComponent("mega-spinner")!
  const _component_fiscal_data = _resolveComponent("fiscal-data")!
  const _component_complete_offer_form = _resolveComponent("complete-offer-form")!
  const _component_stripe_checkout = _resolveComponent("stripe-checkout")!
  const _component_pay_with_deferred = _resolveComponent("pay-with-deferred")!
  const _component_pay_with_saldo = _resolveComponent("pay-with-saldo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (_ctx.showMegaSpinner)
            ? (_openBlock(), _createBlock(_component_mega_spinner, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Transazione in corso...",
                    text: "Transazione in corso..."
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offers, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "wrapSpacer",
          key: item.identifier
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["roundedBox", { selected: _ctx.selectedOffer == item }]),
            onClick: ($event: any) => (_ctx.setOffer(item))
          }, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$filters.currency(_ctx.getGrossAmount(item))) + " " + _toDisplayString(_ctx.currencySymbol), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(item.title.values[_ctx.$store.state.selectedLanguage]), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(item.subTitle.values[_ctx.$store.state.selectedLanguage]), 1)
          ], 10, _hoisted_3)
        ]))
      }), 128))
    ]),
    (_ctx.selectedOffer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (!_ctx.fiscalDataOk)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Per favore, controlla che i dati di fatturazione siano corretti",
                      text: "Per favore, controlla che i dati di fatturazione siano corretti"
                    })
                  ])
                ]),
                _createVNode(_component_fiscal_data, {
                  modelValue: _ctx.$store.state.user,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.$store.state.user) = $event)),
                  user: _ctx.$store.state.user
                }, null, 8, ["modelValue", "user"]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fiscalDataNext && _ctx.fiscalDataNext(...args))),
                    class: "btn btn-primary",
                    disabled: !_ctx.canFiscalDataOk
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Avanti",
                      text: "Avanti"
                    })
                  ], 8, _hoisted_12)
                ])
              ]))
            : (_ctx.selectedOffer.useBuyForm && !_ctx.formOk)
              ? (_openBlock(), _createBlock(_component_complete_offer_form, {
                  key: 1,
                  offer: _ctx.selectedOffer,
                  cart: _ctx.shoppingCart,
                  onPrev: _cache[2] || (_cache[2] = ($event: any) => (_ctx.fiscalDataOk = false)),
                  onNext: _cache[3] || (_cache[3] = ($event: any) => (_ctx.formOk = true))
                }, null, 8, ["offer", "cart"]))
              : (_ctx.fiscalDataOk)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-link btn-sm",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.fiscalDataOk = false; _ctx.formOk = false;})
                      }, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Indietro",
                          text: "Indietro"
                        })
                      ])
                    ]),
                    _hoisted_14,
                    _createElementVNode("div", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentMethodsAvailable, (method, i) => {
                        return (_openBlock(), _createElementBlock("button", {
                          type: "button",
                          class: _normalizeClass(["btn btn-primary maxw-160 btn-sm", { disabled: _ctx.metodoPagamento != method }]),
                          key: i,
                          onClick: ($event: any) => (_ctx.metodoPagamento = method)
                        }, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Paga con ",
                            text: "Paga con "
                          }),
                          _createTextVNode(" " + _toDisplayString(method.title.values[_ctx.$store.state.selectedLanguage]), 1)
                        ], 10, _hoisted_16))
                      }), 128))
                    ])
                  ], 64))
                : _createCommentVNode("", true),
          _hoisted_17,
          (_ctx.metodoPagamento && _ctx.metodoPagamento.methodType == 'Stripe')
            ? (_openBlock(), _createBlock(_component_stripe_checkout, {
                key: 3,
                class: "mt-4",
                "intent-cb": _ctx.sessionCbStripe,
                "config-cb": _ctx.paymentConfigCbStripe,
                "stripe-key": _ctx.stripePublicKey,
                onComplete: _ctx.onPayCompleteCard
              }, null, 8, ["intent-cb", "config-cb", "stripe-key", "onComplete"]))
            : (_ctx.metodoPagamento && _ctx.metodoPagamento.methodType == 'Deferred')
              ? (_openBlock(), _createBlock(_component_pay_with_deferred, {
                  key: 4,
                  onPay: _ctx.payDeferred
                }, null, 8, ["onPay"]))
              : (_ctx.metodoPagamento && _ctx.metodoPagamento.methodType == 'Saldo')
                ? (_openBlock(), _createBlock(_component_pay_with_saldo, {
                    key: 5,
                    onPay: _ctx.paySaldo
                  }, null, 8, ["onPay"]))
                : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}